export default "__VITE_ASSET__Bdq6bpeo__"